import _ from "lodash";

import NoPrint from "components/NoPrint";
import Stack from "components/Stack";

import MemoSectionContextButton from "entities/Memo/components/Sections/ContextButton";
import NASection from "entities/Memo/components/Sections/NASection";
import NoProformaUploaded from "entities/Memo/components/Sections/NoProformaUploaded";
import SectionSummary from "entities/Memo/components/Sections/Summary";
import { IMemoSection } from "entities/Memo/sdk";
import { useRentalDataManager } from "entities/Memo/utils";
import ProfromaUnitMixAndRent from "entities/Proforma/components/ProfromaUnitMixAndRent";

interface ISectionUnitMixAndRent {
  dealId: number;
  externalToken?: string;
  section?: IMemoSection;
  onUpdate?: () => void;
}

const SectionUnitMixAndRent: React.FC<ISectionUnitMixAndRent> = ({
  dealId,
  externalToken,
  section,
  onUpdate,
}) => {
  const { data: rentalIncomeData } = useRentalDataManager({
    token: externalToken,
    dealId,
  });

  return (
    <>
      {rentalIncomeData &&
      !_.isEmpty(
        rentalIncomeData.rental_data.new_unit_mix_and_rent_and_floor_area
      ) ? (
        <Stack spacing={2} data-testid="unit-mix-and-rent-section">
          {section && _.isUndefined(externalToken) && (
            <NoPrint
              sx={{
                alignSelf: "flex-end",
              }}
            >
              <MemoSectionContextButton
                dealId={dealId}
                section={section}
                onUpdate={onUpdate}
              />
            </NoPrint>
          )}
          {section?.is_na ? (
            <NASection />
          ) : (
            <Stack justifyContent="space-between" spacing={4}>
              <ProfromaUnitMixAndRent rentalIncomeData={rentalIncomeData} />
              <SectionSummary
                title="Unit Mix &amp; Rent description"
                category="Unit Descriptions"
                dealId={dealId}
                externalToken={externalToken}
              />
            </Stack>
          )}
        </Stack>
      ) : (
        <NoProformaUploaded title="Unit Mix &amp; Rent" />
      )}
    </>
  );
};

export default SectionUnitMixAndRent;
